<style lang="less" scoped>
.el-contain {
    box-sizing: border-box;
    position: relative;
    display: flex;
    // flex-direction: column;
    width: 100%;
    height: 100%;
    background: #F4F8FF;
    .canvas-contain {
      // flex: 1;
      // padding-top: 40px;
      padding: 40px 16px 16px 16px;
      height: 100%;
      margin: auto;
      width: 100%;
      // height:100%;
    }
    .item-title-contain {
        position: absolute;
        top: 0;
        left: 0;
        padding-top: 12px;
        padding-left: 16px;
        text-align: left;
        .title {
            margin-bottom: 0px;
            line-height: 22px;
            font-size: 14px !important;
            font-weight: 400;
            color: #606266;
        }
        .num {
          margin-bottom: 0px;
          line-height: 32px;
          font-size: 24px;
          font-weight: 600;
          color: #606266;
        }
    }
    .supplement {
        // padding-left: 16px;
        margin: 0 5px;
        p {
            font-size: 14px;
            // text-align: center;
        }
        .rise {
            color: red;
        }
        .drop {
            color: green;
        }
    }
}
</style>
<template>
  <div 
    class="el-contain"
  >
    <!-- echarts 容器 -->
    <div class="canvas-contain">
      <div
        ref="item-el"
        style="width:100%;height:100%"
      />
    </div>
    <!-- title/num -->
    <div class="item-title-contain">
      <p class="title">
        {{ itemProps.title || '--' }}
      </p>
      <p class="num">
        {{ itemProps.number || '--' }}
      </p>
      <div class="supplement">
        <p
          :class="{
            'rise': itemProps.isRise,
            'drop': !itemProps.isRise
          }"
        >
          环比上月：{{ `${itemProps.d_percent}${itemProps.isRise?'↑':'↓'}` }}  |  {{ `${itemProps.d_count}${itemProps.isRise?'↑':'↓'}` }}
        </p>
      </div>      
    </div>
    <!-- 补充说明 -->
  </div>
</template>
<script>
  import echarts from 'echarts'
  import { generate_element_fields } from './element'
  export default {
    props:{
      itemProps: {
        type:Object,
        default:() => ({})
      }
    },
    data() {
      return {}
    },
    mounted() {
      this.echarts = echarts.init(this.$refs['item-el'], 'walden')
      // this.echarts.setOption(element_fields);
    },
    methods: {
      updateEcharts() {
        // this.itemProps.min
        const element_fields = generate_element_fields()
        if (!this.itemProps.line_data || (this.itemProps.line_data && !this.itemProps.line_data.length)) {
          this.echarts.setOption(element_fields);
          return
        }
        if (this.itemProps.minInterval !== undefined) {
          element_fields.yAxis[0].minInterval = this.itemProps.minInterval
        } 
        element_fields.yAxis[0].scale = true
        element_fields.series[0].data = this.itemProps.line_data.map(item => item).slice(0)
        this.echarts.setOption(element_fields);
      },
      getResize() {
        return this.echarts.resize
      }
    },
  }
</script>
